import variable from "./../variables/platform";

export default (variables = variable) => {
  const tabTheme = {
    flex: 1,
    backgroundColor: "transparent"
  };

  return tabTheme;
};
